// src/pages/UnverifiedUsersPage.jsx

import React, { useState } from 'react';
import {
  Box,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  useToast,
} from '@chakra-ui/react';

const mockUsers = [
  { userId: 'cog_abc123', email: 'user1@example.com', email_verified: false },
  { userId: 'cog_def456', email: 'user2@example.com', email_verified: true },
  { userId: 'cog_ghi789', email: 'user3@example.com', email_verified: false },
];

const UnverifiedUsersPage = () => {
  const [cooldownUserId, setCooldownUserId] = useState(null);
  const toast = useToast();

  const handleSendVerification = (userId) => {
    toast({ title: `Verification email sent to ${userId}`, status: 'info' });
    setCooldownUserId(userId);
    setTimeout(() => setCooldownUserId(null), 60000); // 60 second cooldown

    // Future implementation: call your Lambda to trigger Cognito email verification
    // await fetch('/api/send-verification-email', { method: 'POST', body: JSON.stringify({ userId }) })
  };

  const unverifiedUsers = mockUsers.filter((user) => !user.email_verified);

  return (
      <Box p={8}>
        <Heading mb={6}>Unverified Email Users</Heading>
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>Email</Th>
              <Th>User ID</Th>
              <Th>Action</Th>
            </Tr>
          </Thead>
          <Tbody>
            {unverifiedUsers.map((user) => (
              <Tr key={user.userId}>
                <Td>{user.email}</Td>
                <Td>{user.userId}</Td>
                <Td>
                  <Button
                    size="sm"
                    colorScheme="teal"
                    isDisabled={cooldownUserId === user.userId}
                    onClick={() => handleSendVerification(user.userId)}
                  >
                    Send Verification Email
                  </Button>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
  );
};

export default UnverifiedUsersPage;